import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { ANY_ERROR } from '../../../../action/user_action_types';

import { fileUrl } from '../../../../config';
import SideBar from '../../common/sideBar';
import { history } from '../../../../history/history';

import { getCityState } from '../../../../action/user_action';
import { endPoints } from '../../../../config';
import http from '../../../../util/http';

import { getServerDataWithTypes } from '../../../../action/common_action';
import { SALES_USERS_DATA, STATE_LIST } from '../../../../action/salesUser_action_types';
import { axiosInstnace as Axios } from '../../../../util/util';
// import { Multiselect } from 'multiselect-react-dropdown';
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css"
import HeaderAdminpanel from '../../common/HeaderAdminpanel';

class editClusterofCluster extends Component {
  constructor(props) {
    super(props);
    let clusterData = this.props.location.state.clusterData? this.props.location.state.clusterData : undefined;
    this.handleChangeSelectedItems = this.handleChangeSelectedItems.bind(this);
    this.state = {
      clusterField: {
          email: clusterData && clusterData.cluster && clusterData.cluster.email ? clusterData.cluster.email : '',
          name: clusterData && clusterData.cluster && clusterData.cluster.name ? clusterData.cluster.name : '',
          mobile: clusterData && clusterData.cluster && clusterData.cluster.mobile ? clusterData.cluster.mobile : '',
          clusterList: clusterData && clusterData.cluster && clusterData.cluster.clusterList ? clusterData.cluster.clusterList : '',
      },
      clusterList:["Select City"],
      clusterName: "",
      clusterCities: clusterData && clusterData.cluster && clusterData.cluster.clusterList ? clusterData.cluster.clusterList : [],
      clusterStates: []
  };
  };

  componentDidMount = () => {
    this.getAllStates();

}

getAllStates = async() => {
    const response = await Axios.get(`${endPoints.getClusters}`, {params:{type:"all"}});
    let clusters =   response.data.data.allData.filter(e=> e.name !== this.state.clusterField.name)
    this.setState({
        clusterList: clusters.map((e)=>{
          return {
            id: e._id,
            label: e.name,
            name: e.name
          }
        })
      })

}



componentWillReceiveProps = nextProps => {
    console.log('on Data receive props on Add cluster page', nextProps);
    let {stateList} = nextProps;
    this.setState({
        stateList: (stateList && stateList.data) ? stateList.data : []
    })
}

handleChangeSelectedItems(clusterCities) {
  console.log(clusterCities);
  this.setState({ clusterCities });
}


serverCalls= async(url, data)=> {
    const response= await http.put(url, data);
    if(response && response.data.statusCode== 200) {
        // this.componentDidMount();
        var data = response.data.data[0] ? response.data.data[0] : response.data.data ;
        console.log('Response', data);
        // this.state.clusterField.name = data.name;
        // this.state.clusterField.email = data.email;
      this.goToRoute('clusterOfClusterlist', null, '/admin/clusterOfClusterlist')

    }
    else {
        this.props.showError(response? response.data.message: "Something is wrong");
    }
}

EditClusters = () => {
  let adminInfo = JSON.parse(localStorage.getItem('adminInfo')) ;
  console.log(adminInfo);
  let data = {
    name:this.state.clusterField.name,
    clusterList: this.state.clusterCities,
    email: adminInfo.email
  }
  if(this.state.clusterField.name && this.state.clusterField.name != ""){
    if((this.state.clusterCities && this.state.clusterCities.length >0 || this.state.clusterStates && this.state.clusterStates.length>0)){
      this.serverCalls(endPoints.editClusterOfCluster, data);
    }else {
      this.props.showError('Please Add a State or City to the List ');
    }

  }else {
    this.props.showError('Please Enter name');
  }
}

  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  }

  //View campaign info
  render() {
    let { clusterField } = this.state;
    let { hidePopup }= this.props;
    let { name }= clusterField;
    const { clusterList, clusterCities } = this.state;
    

    return (
      <div>
        <div className="dashboardContainer">
         <HeaderAdminpanel/>
          <div className="dashboardContainer-inner">
                <section id="sidebar">
                 <SideBar />          
                </section>
            <section id="dashboard-rightContainer" className="dashboard-manageSales brands-head">
              <div className="container-head">
                <div className="dashboard-breadcrumb">System Configuration | Cluster List |
                  <span className="blue_camp">Edit Cluster of Cluster</span></div>
              </div>

              <table className="tableView">
                  <tr>
                      <td>
                          <label htmlFor="email">Name</label>
                      </td>
                      <td>
                          <input type= "email" name= "email" placeholder="Name" disabled value={clusterField.name}  className="width200 inputBox" />
                      </td>
                      
                  </tr>
                  <tr>
                      
                  </tr>
              </table>

              <MultiSelect
                items={clusterList}
                selectedItems={clusterCities}
                onChange={this.handleChangeSelectedItems}
                withGrouping
              />

              <div className="view-btn_wrapper">
                <button className="cluster-add-btn" onClick={this.EditClusters}>Update cluster</button>
                <button className="cluster-add-btn"
                  onClick={() => this.goToRoute('clusterOfClusterlist', null, '/admin/clusterOfClusterlist')}>BACK</button>
              </div>
              
            </section>
          </div>
        </div>
      </div>
    );
  };
};

const mapStateToProps = state => { console.log(state);
  return {
    stateList: state.sales.get("stateList")
  }
};
const mapDispatchToProps = dispatch => {
  return {
    showError: error => dispatch({
      type: ANY_ERROR,
      payload: error
    }),
    getStateList: (url, data, type) => dispatch(getServerDataWithTypes(url, data, type))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(editClusterofCluster);



// WEBPACK FOOTER //
// ./web/components/admin/users/salesUser/editClusterofCluster.jsx